module.exports = __webpack_public_path__ + "img/nixt_logo.207d65e4.svg";